<template>
  <div>
    <div class="form-section">
      <div class="content-section">
        <div :class="{'form-field':true,'invalid':(!form.inn.valid && form.inn.tochted) || !!errors.inn}" >
          <label for="company-inn">ИНН:</label>
          <input
            id="company-inn"
            type="text"
            v-model="form.inn.value"
            @blur="form.inn.blur"
            />
          <small v-if="form.inn.tochted && fieldError(form.inn)" class="field-error">{{ fieldError(form.inn) }}</small>
        </div>
        <div class="form-field">
          <label for="company-name">Название:</label>
          <input 
            id="company-name" 
            type="text" 
            v-model="form.name.value"
            @blur="form.name.blur" />
        </div>
        <div class="form-field">
          <label for="company-director">Директор:</label>
          <input 
            id="company-director" 
            type="text" 
            v-model="form.director.value"
            @blur="form.director.blur" />
        </div>
        <div class="form-field">
          <label for="company-phone">Телефон:</label>
          <input
            id="company-phone"
            type="text"
            v-model="form.phone.value"
            @blur="form.phone.blur" />
          <small v-if="form.phone.tochted && fieldError(form.phone)" class="field-error">{{ fieldError(form.phone) }}</small>
        </div>

        <div class="form-field">
          <label for="company-email">Email:</label>
          <input
            id="company-email"
            type="text"
            v-model="form.email.value"
            @blur="form.email.blur" />
          <small v-if="form.email.tochted && fieldError(form.email)" class="field-error">{{ fieldError(form.email) }}</small>
        </div>
        <div class="form-field">
          <label for="company-address">Адрес:</label>
          <input 
            id="company-address" 
            type="text" 
            v-model="form.address.value"
            @blur="form.address.blur" />
        </div>
      </div>

      <div>
        <my-shrunk-button
          class="create-btn"
          @click="sendForm"
         :btnSettings="{shrunk:true,name:''}">Сохранить
        </my-shrunk-button>
      </div>

    </div>

  </div>
</template>


<script>
import { useForm,useFormat } from '@/hooks/form'
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute,useRouter } from 'vue-router';

export default {
  name: 'CustomerForm',
  setup(_,{emit}){

    const form = useForm({
      inn: {
        value:'',
        validators:['inn']
      },
      name: {
        value:'',
        validators:['required']
      },
      director:{
        value:'',
        validators:[]
      },
      phone: {
        value:'',
        validators:['phone']
      },
      email: {
        value:'',
        validators:['email']
      },
      address: {
        value:'',
        validators:[]
      },
    })

    const store = useStore()
    const errors = computed(() => store.state.apiStorage.customers?.formErrors || {})
    const fieldError = (field) => Object.values(field.errors).find(Boolean) || ''

    const sendForm = () => {
      Object.keys(form).forEach((key) => {
        if (key !== 'valid' && typeof form[key]?.blur === 'function') {
          form[key].blur()
        }
      })
      if (!form.valid) return
      emit('sendForm', { model: 'customers', form: useFormat(form) })
    }
      
    return {
      form,
      errors,
      fieldError,
      sendForm
    }
  }

};
</script>


<style scoped>

.form-section {
  height: 100%;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  padding: 20px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.content-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.checkbox-container-glonas{
  display: flex;
  align-items: center;
  text-align: center;
}

.checkbox-container-glonas input{
  margin-bottom: 6px;
}
.checkbox-container-glonas label{
  margin-right: 10px;
  
/*  margin: 0;*/
}

.form-section > div {
  margin-bottom: 10px;
}

.form-section label {
  display: block;
  margin-bottom: 5px;
}

.form-section input[type="text"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.invalid input{
  border: 1px solid;
  border-color: rgba(255,0,0, 1);
  box-shadow: 0 0 9px 2px rgba(255, 0, 0, 0.4);
/*  outline: none;*/
}

.field-error {
  display: block;
  margin-top: 3px;
  font-size: 12px;
  color: #c62828;
}

.form-field input:focus {
  border-color: rgba(79,70,229, 0.6); /* Измените цвет на нужный вам */
  outline: rgba(79,70,229, 0); /* Убирает контур фокуса по умолчанию */
}
</style>